export const MISSING_CROP_PICTURE_CODE = 'MISSING_CROP_PICTURE' as const;

export const MISSING_CROP_PICTURES_EVENT = 'lidea-missing-crop-pictures';

export type MissingCropPictureDrop = {
  measureId?: number;
  field?: string;
  pictureId?: string;
};

export type MissingCropPicturesEventDetail = {
  dropped: MissingCropPictureDrop[];
};

let lastDroppedCropPictures: MissingCropPictureDrop[] = [];

/** Read-and-clear drops recorded during the last rehydrate (restore may beat React listeners). */
export function consumeMissingCropPictureDrops(): MissingCropPictureDrop[] {
  const dropped = lastDroppedCropPictures;
  lastDroppedCropPictures = [];
  return dropped;
}

/** Thrown when a paused upload can no longer recover its local File/blob. */
export class MissingCropPictureError extends Error {
  readonly code = MISSING_CROP_PICTURE_CODE;

  constructor(
    message = 'Crop picture is missing from offline storage'
  ) {
    super(message);
    this.name = 'MissingCropPictureError';
  }
}

export function isMissingCropPictureError(error: unknown): boolean {
  if (error instanceof MissingCropPictureError) {
    return true;
  }
  return (
    !!error &&
    typeof error === 'object' &&
    'code' in error &&
    (error as { code?: string }).code === MISSING_CROP_PICTURE_CODE
  );
}

export function notifyMissingCropPictures(
  dropped: MissingCropPictureDrop[]
): void {
  lastDroppedCropPictures = dropped;
  if (dropped.length === 0 || typeof window === 'undefined') {
    return;
  }
  window.dispatchEvent(
    new CustomEvent(MISSING_CROP_PICTURES_EVENT, {
      detail: { dropped } satisfies MissingCropPicturesEventDetail,
    })
  );
}
